import React, { useEffect, useState } from "react";
import Compensationimg from "../../Assets/Img/Compensationimg.png";
import ExpectedDeliverablesimg from "../../Assets/Img/ExpectedDeliverablesimg.png";
import TargetAudienceimg from "../../Assets/Img/TargetAudienceimg.png";
import { useParams } from "react-router-dom";
import axiosMain from "../../http/axiosMain";
import Banner from "../../Assets/Img/Banner.jpg";
function CampaignDetails() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedAge, setSelectedAge] = useState(null);
  const { id } = useParams();
  const [CampaignFormCreate, setCampaignFormCreate] = useState(null);
  const fetchCampaign = async () => {
    try {
      const response = await axiosMain.get("/api/v1/campaigns", {
        params: {
          campaign_id: id,
        },
      });
      setCampaignFormCreate(response.data.campaigns[0]);
    } catch (error) {
      console.error("Error fetching campaign:", error);
    }
  };
  useEffect(() => {
    fetchCampaign();
  }, []);

  return (
    <div>
      <div>
        <h2 className="Title">Campaign Details</h2>
        {/* Overview content goes here */}
        <div className="WhiteBox">
          {/* Header Section */}
          <div className="BannerBox">
          <img
            src={CampaignFormCreate?.campaign_poster} // Use dynamic image
            className="img-fluid"
            alt="Campaign Banner"
          />
          </div>
          <div className="header-section mb-4">
            <h2 className="Title detail-title">
              {CampaignFormCreate?.campaign_title
                ? CampaignFormCreate?.campaign_title
                : "-"}
            </h2>
            <p className="subtitle">{CampaignFormCreate?.campaign_obj}</p>
          </div>

          {/* Description Section */}
          <div className="description-section mb-4">
            <p>{CampaignFormCreate?.description}</p>
          </div>

          {/* Compensation Section */}
          <div className="info-section mb-4">
            <h2>Compensation</h2>
            <div className="info-content">
              <img
                src={Compensationimg}
                alt="compensation"
                className="info-icon"
              />
              <p>Flat fee and Product • {CampaignFormCreate?.budget}</p>
            </div>
          </div>

          {/* Deliverables Section */}
          <div className="info-section mb-4">
            <h2>Expected Deliverables</h2>
            <div className="info-content">
              <img
                src={ExpectedDeliverablesimg}
                alt="deliverables"
                className="info-icon"
              />
              <p>
                2 Posts & 1 Reel • From {startDate} to {endDate}
              </p>
            </div>
          </div>

          {/* Target Audience Section */}
          <div className="info-section mb-4">
            <h2>Target Audience</h2>
            <div className="info-content">
              <img src={TargetAudienceimg} alt="target" className="info-icon" />
              <div className="audience-info">
                <p>
                  {selectedAge} Years old • {CampaignFormCreate?.gender} •
                  {CampaignFormCreate?.city},{CampaignFormCreate?.state}
                </p>
                <div className="tags">
                  <span className="tag">{CampaignFormCreate?.language}</span>
                  <span className="tag">{CampaignFormCreate?.language}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CampaignDetails;